// eslint-disable-next-line simple-import-sort/imports
import React, { Suspense } from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { Provider } from 'react-redux'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import {
  CircularProgressOverlay,
  muiTheme,
  SentryUtils,
  Utils,
} from '@pbt/pbt-ui-components'

import './locales/i18n'

import App from './components/App'
import { ChirpThemeWrapper } from './components/ChirpThemeWrapper'
import { store } from './store'
import { initLogRocket } from './utils/LogRocket'

import './index.scss'
import '@chewy/audio-to-notes-ui/audio-to-notes-ui.css'

import { registerTrackingProvider } from './utils/trackingProvider'
import { AgentChatProvider } from './components/agent/AgentChatContext'

SentryUtils.initSentry()
initLogRocket()

if (Utils.isLocalEnvironment()) {
  registerTrackingProvider({
    track: (eventName, meta) => {
      if (window.pbt && window.pbt.getLogTrackingEventsEnabled()) {
        // eslint-disable-next-line no-console
        console.log('Tracking event:', eventName, meta)
      }
    },
  })
}

const root = ReactDOMClient.createRoot(
  document.getElementById('root') as HTMLElement,
)

root.render(
  <Provider store={store}>
    <StyledEngineProvider injectFirst>
      <ChirpThemeWrapper />
      <ThemeProvider theme={muiTheme}>
        <Suspense fallback={<CircularProgressOverlay open />}>
          <AgentChatProvider>
            <App />
          </AgentChatProvider>
        </Suspense>
      </ThemeProvider>
    </StyledEngineProvider>
  </Provider>,
)
